import { NgModule } from '@angular/core';
import { StatusCommentsComponent } from './status-comments.component';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { ApprovalListModule } from '../approval-list-modal/approval-list.module';
import { TranslateModule } from '@ngx-translate/core';
import { CorePipesModule } from '@core/pipes/pipes.module';
import { CoreDirectivesModule } from '@core/directives/directives';
import { IconsModule } from 'app/components/icons';

@NgModule({
  declarations: [StatusCommentsComponent],
  imports: [
    FormsModule,
    CommonModule,
    ApprovalListModule,
    TranslateModule,
    CorePipesModule,
    CoreDirectivesModule,
    IconsModule
  ],
  exports: [StatusCommentsComponent]
})
export class StatusCommentsModule {}
